/** Brand logos served from /public/images/logos/ */
export const BRAND_LOGO_LIGHT_BG = "/images/logos/logo.png";
export const BRAND_LOGO_DARK_BG = "/images/logos/logo-dark.png";
export const BRAND_FAVICON = "/images/logos/favicon.png";
